"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = GooglePay;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function GooglePay(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: ".cls-1{fill:#606469;}.cls-2{fill:#557ebf;}.cls-3{fill:#36a852;}.cls-4{fill:#f9bc15;}.cls-5{fill:#ea4535;}"
    }
  })), /*#__PURE__*/_react["default"].createElement("title", null, "Google Pay"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Payment_methods",
    "data-name": "Payment methods"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "google-pay"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M47.43,49.57V60.632H43.918V33.309h9.309a8.41,8.41,0,0,1,6.029,2.365,7.905,7.905,0,0,1,0,11.567,8.384,8.384,0,0,1-6.029,2.325l-5.8,0Zm0-12.9v9.54h5.885a4.755,4.755,0,0,0,3.563-8c-.031-.031-.059-.063-.091-.091a4.576,4.576,0,0,0-3.472-1.449Zm22.433,4.654a8.7,8.7,0,0,1,6.144,2.079,7.379,7.379,0,0,1,2.25,5.7V60.632H74.9v-2.6h-.151a6.707,6.707,0,0,1-5.8,3.2,7.528,7.528,0,0,1-5.168-1.832A5.851,5.851,0,0,1,61.7,54.83a5.555,5.555,0,0,1,2.194-4.615A9.258,9.258,0,0,1,69.752,48.5,10.39,10.39,0,0,1,74.9,49.642v-.8a4,4,0,0,0-1.449-3.106,4.972,4.972,0,0,0-3.389-1.278,5.379,5.379,0,0,0-4.655,2.481l-3.089-1.948a8.591,8.591,0,0,1,7.545-3.659ZM65.32,54.91a2.81,2.81,0,0,0,1.163,2.29,4.281,4.281,0,0,0,2.727.915,5.609,5.609,0,0,0,3.95-1.64A5.127,5.127,0,0,0,74.9,52.62a7.171,7.171,0,0,0-4.579-1.31,5.928,5.928,0,0,0-3.568,1.032A3.089,3.089,0,0,0,65.32,54.91ZM97.528,41.937,85.81,68.874H82.187l4.348-9.425L78.826,41.937h3.815l5.57,13.431h.076l5.419-13.431Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-2",
    d: "M33.243,47.181a18.668,18.668,0,0,0-.271-3.193h-14.8v6.044h8.477a7.257,7.257,0,0,1-3.134,4.77v3.927h5.061a15.341,15.341,0,0,0,4.671-11.548Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-3",
    d: "M18.168,62.523a15.01,15.01,0,0,0,10.4-3.791l-5.061-3.926A9.517,9.517,0,0,1,9.356,49.829H4.144v4.046A15.693,15.693,0,0,0,18.168,62.523Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-4",
    d: "M9.356,49.829a9.4,9.4,0,0,1,0-6.008V39.775H4.144a15.7,15.7,0,0,0,0,14.1Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-5",
    d: "M18.168,37.342a8.527,8.527,0,0,1,6.02,2.354l4.484-4.48a15.1,15.1,0,0,0-10.5-4.089A15.7,15.7,0,0,0,4.144,39.775l5.212,4.046A9.389,9.389,0,0,1,18.168,37.342Z"
  }))));
}